fabric.util.object.extend(fabric.Triangle.prototype, {
  _render(ctx) {
    const tg = this.height / (this.width / 2);
    const angle = Math.atan(tg);
    const deltaWdth = this.strokeWidth / 2 / Math.tan(angle / 2);
    const widthBy2 = this.width / 2 - deltaWdth,
      heightBy2 = (widthBy2 * tg) / 2;
    ctx.beginPath();
    ctx.moveTo(-widthBy2, heightBy2);
    ctx.lineTo(0, -heightBy2);
    ctx.lineTo(widthBy2, heightBy2);
    ctx.closePath();
    this._renderFill(ctx);
    this._renderStroke(ctx);
  },
  _calculateCurrentDimensions() {
    let w = this.width;
    let h = this.height;

    w = w * this.scaleX + 2 * this.padding;
    h = h * this.scaleY + 2 * this.padding;

    return { x: w, y: h };
  }
});
